export enum Models {
  SONNET_4_5 = 'us.anthropic.claude-sonnet-4-5-20250929-v1:0',
  SONNET_4_6 = 'us.anthropic.claude-sonnet-4-6',
  SONNET_5 = 'us.anthropic.claude-sonnet-5',
  OPUS_5_5 = 'us.anthropic.claude-opus-5-5',
  OPUS_5 = 'us.anthropic.claude-opus-5',
  OPUS_4_8 = 'us.anthropic.claude-opus-4-8',
  HAIKU_4_5 = 'us.anthropic.claude-haiku-4-5-20251001-v1:0',
  GPT_5_1 = 'gpt-5.1',
  GPT_5_2 = 'gpt-5.2',
  GPT_5_5 = 'gpt-5.5',
  GPT_5_MINI = 'gpt-5-mini',
  GPT_5_6_SOL = 'gpt-5.6-sol',
  GPT_5_6_TERRA = 'gpt-5.6-terra',
  GPT_5_6_LUNA = 'gpt-5.6-luna',
  GPT_6_SOL = 'gpt-6-sol',
  GPT_6_LUNA = 'gpt-6-luna',
  /** Cheap Bedrock aliases (proxy-server bedrock + modelpolicy catalog). */
  NOVA_LITE = 'nova-lite',
  NOVA_2_LITE = 'nova-2-lite',
  QWEN3_32B = 'qwen3-32b',
  DEEPSEEK_V3_2 = 'deepseek-v3.2',
  LLAMA4_SCOUT = 'llama4-scout',
  LLAMA4_MAVERICK = 'llama4-maverick',
  MISTRAL_LARGE_3 = 'mistral-large-3',
  KIMI_K2 = 'kimi-k2',
  GROK_4_3 = 'grok-4.3',
  GEMMA_4 = 'gemma-4'
}

export enum Providers {
  BEDROCK = 'bedrock',
  ANTHROPIC = 'anthropic',
  OPENAI = 'openai'
}

/**
 * Task classes sent to the proxy as `model_class` instead of a concrete model
 * ID. The proxy resolves each class to a provider/model through the calling
 * org's model policy (values mirror proxy-server's
 * internal/ontology/modelpolicy task-class constants).
 */
export enum ModelTaskClass {
  STANDARD = 'standard',
  HEAVY = 'heavy',
  DASHBOARD = 'dashboard',
  LIGHT = 'light'
}
